export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3 whitespace-nowrap">
            Hot Videos
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            热门吃瓜现场
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          <div className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20pop%20art%20style%20illustration%20of%20entertainment%20news%20cover%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20megaphone%20and%20star%20motifs%2C%20newspaper%20headline%20aesthetic%2C%20trending%20topic%20visual%2C%20bold%20graphic%20composition%2C%20clean%20modern%20layout%2C%20no%20text%2C%20warm%20dark%20background&width=640&height=360&seq=mrds-media-01&orientation=landscape"
                alt="本周最劲爆：某顶流深夜密会画面曝光"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                HOT
              </span>
              <div className="absolute bottom-3 right-3">
                <span className="text-xs text-background-50/90 whitespace-nowrap">289万</span>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">爆款视频</span>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                本周最劲爆：某顶流深夜密会画面曝光
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                独家整理事件时间线，从相识到被拍全过程还原
              </p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20pop%20art%20style%20illustration%20of%20entertainment%20news%20cover%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20megaphone%20and%20star%20motifs%2C%20newspaper%20headline%20aesthetic%2C%20trending%20topic%20visual%2C%20bold%20graphic%20composition%2C%20clean%20modern%20layout%2C%20no%20text%2C%20warm%20dark%20background&width=640&height=360&seq=mrds-media-02&orientation=landscape"
                alt="七月吃瓜月报：十大不可错过名场面"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                HOT
              </span>
              <div className="absolute bottom-3 right-3">
                <span className="text-xs text-background-50/90 whitespace-nowrap">176万</span>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">热门盘点</span>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                七月吃瓜月报：十大不可错过名场面
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                本月最具话题度的娱乐事件一次性回顾
              </p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20pop%20art%20style%20illustration%20of%20entertainment%20news%20cover%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20megaphone%20and%20star%20motifs%2C%20newspaper%20headline%20aesthetic%2C%20trending%20topic%20visual%2C%20bold%20graphic%20composition%2C%20clean%20modern%20layout%2C%20no%20text%2C%20warm%20dark%20background&width=640&height=360&seq=mrds-media-03&orientation=landscape"
                alt="圈内人爆料：综艺选秀背后的资本博弈"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-3 right-3">
                <span className="text-xs text-background-50/90 whitespace-nowrap">143万</span>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">深度解读</span>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                圈内人爆料：综艺选秀背后的资本博弈
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                知情人士独家披露选秀节目的幕后运作机制
              </p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20pop%20art%20style%20illustration%20of%20entertainment%20news%20cover%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20megaphone%20and%20star%20motifs%2C%20newspaper%20headline%20aesthetic%2C%20trending%20topic%20visual%2C%20bold%20graphic%20composition%2C%20clean%20modern%20layout%2C%20no%20text%2C%20warm%20dark%20background&width=640&height=360&seq=mrds-media-04&orientation=landscape"
                alt="本周最佳吃瓜表情包大赏"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                HOT
              </span>
              <div className="absolute bottom-3 right-3">
                <span className="text-xs text-background-50/90 whitespace-nowrap">98万</span>
              </div>
            </div>
            <div className="p-4">
              <span className="inline-block text-xs text-accent-600 font-medium mb-2 whitespace-nowrap">梗图合集</span>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                本周最佳吃瓜表情包大赏
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                网友自制表情包大盘点，每一张都是名场面
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}